import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { getLoggedUser } from "./redux/slices/authSlice";
import { emptyDisputeMedia, getFulfillmentOrders } from "./redux/slices/orderSlice";
import { storeSelector } from "./redux/slices/storeSlice";
import AppRouters from "./routers";
import { setPage, setValue } from "./redux/slices/transactionSlice";
import { setProductTabValue } from "./redux/slices/productSlice";

function App() {
  const { storeInfo } = useSelector(storeSelector);
  const dispatch = useDispatch();
  const location = useLocation()

  useEffect(() => {
    if (storeInfo !== null) {
      dispatch(getLoggedUser(storeInfo));
    }
  }, [dispatch, storeInfo]);

  useEffect(() => {
    if (location?.pathname !== "/customer/orders") {
      dispatch(getFulfillmentOrders([]));
    }
    if (
      !(location?.pathname === "/customer/products" || location?.pathname.startsWith("/customer/products/")) &&
      !(location?.pathname === "/admin/products" || location?.pathname.startsWith("/admin/products/"))
    ) {
      dispatch(setProductTabValue(0));
    }
    
    if(location?.pathname !== "/customer/orders/dispute-list" || location?.pathname !== "/admin/orders/dispute-list"){
      dispatch(emptyDisputeMedia([]))
    }
    if (!location?.pathname.includes("/admin/users")) {
      dispatch(setPage(0));
      dispatch(setValue(0));
    }
  }, [dispatch, location?.pathname]);

  return (
    <div>
      <AppRouters />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
//
export default App;
